'use client';
import { useEffect } from 'react';
import { Drawer } from '@repo/ui/src/modules/UI/components/Drawer';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

interface CartDrawerProps {
  children: React.ReactNode;
  /**
   * Path prefix that disables the drawer automatically (e.g. '/cart' for Traeger,
   * where a dedicated cart page exists). If omitted, no automatic disable logic runs.
   */
  cartPath?: string;
}

export const CartDrawer = ({ children, cartPath }: CartDrawerProps) => {
  const { enable, disable } = useModal(ModalID.cart);
  const { path } = useCurrentUrl();

  useEffect(() => {
    if (!cartPath) return;
    if (path.startsWith(cartPath)) {
      disable();
    } else {
      enable();
    }
  }, [path, cartPath, disable, enable]);

  return <Drawer id={ModalID.cart}>{children}</Drawer>;
};
